import { useEffect, useMemo, useState } from "react";
import { fetchTeamMessages } from "../../../api/client";
import { mergeTaskCommentsWithMessages } from "../utils/taskCommentMedia";

async function loadSpaceMessages(spaceId) {
  const all = [];
  let before;
  for (let page = 0; page < 8; page += 1) {
    const result = await fetchTeamMessages(spaceId, { before, limit: 100 });
    const messages = result?.messages || [];
    all.push(...messages);
    if (!result?.hasMore || result.nextBefore == null) break;
    before = result.nextBefore;
  }
  return all;
}

/**
 * Completa comentários da tarefa com mídia do chat aberto (imagem, arquivo, áudio, vídeo).
 */
export function useEnrichedTaskComments(comments = [], discussionSpaceId = null) {
  const [spaceMessages, setSpaceMessages] = useState([]);

  useEffect(() => {
    const spaceId = Number(discussionSpaceId);
    if (!Number.isFinite(spaceId) || spaceId <= 0) {
      setSpaceMessages([]);
      return undefined;
    }

    let cancelled = false;
    loadSpaceMessages(spaceId)
      .then((messages) => {
        if (!cancelled) setSpaceMessages(messages);
      })
      .catch(() => {
        if (!cancelled) setSpaceMessages([]);
      });

    return () => {
      cancelled = true;
    };
  }, [discussionSpaceId, comments.length]);

  return useMemo(
    () => mergeTaskCommentsWithMessages(comments, spaceMessages),
    [comments, spaceMessages]
  );
}
